import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useEffect } from 'react';
import SubmitSection from '../components/SubmitSection';
import { Formik } from 'formik';
import { FormWrapper, WritingFormsContainer } from '../styles';
import { SourceName, FormMode, BackButtonTexts } from '../types';
import { TestIds } from '../constants';
import { FormHeading } from '../styles';
import { getForm, citationToFormStateTransformation, formStateToCitationTransformation } from '../forms';

// TODO: can be removed
export var transformToStateGeneric = function transformToStateGeneric(citation) {
  return _objectSpread(_objectSpread({}, citation.data), {}, {
    source: citation.data.source,
    pubtype: citation.data.pubtype,
    contributors: citation.contributors,
    annotation: citation.annotation
  });
};

// TODO: can be removed
export var transformToCitationGeneric = function transformToCitationGeneric(state) {
  return {
    data: {
      source: state.source,
      pubtype: state.pubtype,
      annotation: state.annotation || ''
    },
    contributors: state.contributors || [{
      firstName: '',
      lastName: '',
      middleName: '',
      data: {
        suffix: ''
      }
    }],
    annotation: state.annotation || ''
  };
};

/**
 * This container will returns JSX for html form according to the props passed
 * @returns Forms as JSX.Element
 */
var WritingForms = function WritingForms(_ref) {
  var className = _ref.className,
    mode = _ref.mode,
    onCancel = _ref.onCancel,
    backButtonText = _ref.backButtonText,
    intialCitationState = _ref.intialCitationState,
    onSave = _ref.onSave,
    onSourceChange = _ref.onSourceChange,
    trackFormView = _ref.trackFormView,
    adsEnabled = _ref.adsEnabled;
  var source = intialCitationState.data.source;
  var Form = getForm(source);
  var isNewCitation = mode == FormMode.NEW;
  var citationActionTxt = isNewCitation ? 'Add' : 'Edit';
  var state = citationToFormStateTransformation(intialCitationState);
  useEffect(function () {
    trackFormView && trackFormView(source);
  }, [source, trackFormView]);
  var showButtonsInVertical = !!backButtonText && backButtonText !== BackButtonTexts.CANCEL;
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: state,
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state, helper) {
        var citation;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                citation = formStateToCitationTransformation(state); // TODO: to implement promise of successful save
                _context.next = 3;
                return onSave(citation);
              case 3:
                helper.setSubmitting(false);
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }(),
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false
  }, /*#__PURE__*/React.createElement(WritingFormsContainer, {
    className: className,
    "data-test": TestIds.WritingForm
  }, /*#__PURE__*/React.createElement(FormHeading, {
    adsEnabled: adsEnabled
  }, citationActionTxt, " ", SourceName[source], " details"), /*#__PURE__*/React.createElement(FormWrapper, {
    className: "wf-form-wrapper",
    showButtonsInVertical: showButtonsInVertical,
    adsEnabled: adsEnabled
  }, /*#__PURE__*/React.createElement(Form, {
    source: source,
    citation: intialCitationState,
    onSourceChange: onSourceChange
  })), /*#__PURE__*/React.createElement(SubmitSection, {
    isNewCitation: isNewCitation,
    onCancel: onCancel,
    adsEnabled: adsEnabled,
    showButtonsInVertical: showButtonsInVertical,
    backButtonText: backButtonText
  })));
};
export default WritingForms;